import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/index.scss';

import { Col, Container, Row } from 'reactstrap';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import { ordersService } from './services/Orders';
import { pageLoader } from './services/PageLoader';
import { Provider } from 'unstated';
import DashboardPage from './pages/Dashboard';
import InvoicesPage from './pages/Invoices';
import MyDealersPage from './pages/MyDealers';
import MyOrdersPage from './pages/MyOrders';
import NewOrderPage from './pages/NewOrder';
import ProductsPage from './pages/Products';
import CategoriesPage from './pages/Categories';
import ProductDetailsPage from './pages/ProductDetails';

// const DashboardPage = lazy(() => import('./pages/Dashboard'));
// const InvoicesPage = lazy(() => import('./pages/Invoices'));
// const MyDealersPage = lazy(() => import('./pages/MyDealers'));
// const MyOrdersPage = lazy(() => import('./pages/MyOrders'));
// const NewOrderPage = lazy(() => import('./pages/NewOrder'));
// const ProductsPage = lazy(() => import('./pages/Products'));

ReactDOM.render(
  <Provider inject={[ordersService, pageLoader]}>
    <Router>
      <>
        <Sidebar/>

        <div id="page-content-wrapper">
          <Header/>

          <Container fluid>
            <Row>
              <Col xs>
                <Switch>
                  <Suspense fallback={<></>}>
                    {/* General routes */}
                    <Route exact path="/" component={DashboardPage}/>
                    <Route exact path="/new-order" component={NewOrderPage}/>
                    <Route exact path="/my-orders" component={MyOrdersPage}/>
                    <Route exact path="/my-dealers" component={MyDealersPage}/>
                    <Route exact path="/invoices" component={InvoicesPage}/>

                    {/* Dealer routes */}
                    <Route exact path="/:dealer/products" component={CategoriesPage}/>
                    <Route exact path="/:dealer/products/:category" component={ProductsPage}/>
                    <Route exact path="/:dealer/products/:category/:product" component={ProductDetailsPage}/>
                  </Suspense>
                </Switch>
              </Col>
            </Row>
          </Container>
        </div>
      </>
    </Router>
  </Provider>,
  document.getElementById('root')
);
